import { useMemo } from "react";
import { useTypedSelector } from "../../../../store/reducers/use-typed-selector";

const useTranslationsV2 = () => {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const featureFlags = useTypedSelector(state => state.FeatureFlagsReducer.featureFlags);

	return useMemo(() => {
		if (!workingEvent) {
			return false;
		}

		return featureFlags["streams.translations_v2"] && workingEvent.settings.translation_version === 2;
	}, [workingEvent, featureFlags]);
};

export default useTranslationsV2;